import React, { useState } from 'react';
import { Bell, Lock, Globe, HardDrive, CreditCard, LifeBuoy, Activity, Check, Shield, Key, Smartphone, AlertTriangle, RefreshCw, Clock, Zap, FileText, User, Mail, Calendar, DollarSign, Receipt, HelpCircle, MessageSquare, BookOpen, ExternalLink, Headphones, Server, Database } from 'lucide-react';
const Settings = () => {
  const [activeTab, setActiveTab] = useState('notifications');
  return <div className="h-[calc(100vh-8rem)] flex flex-col" data-id="element-1952">
      <div className="flex items-center justify-between mb-6 flex-shrink-0" data-id="element-1953">
        <div data-id="element-1954">
          <h1 className="text-2xl font-bold tracking-tight" data-id="element-1955">Settings</h1>
          <p className="text-muted-foreground" data-id="element-1956">
            Manage your account settings and preferences
          </p>
        </div>
      </div>

      {/* Horizontal Tabs */}
      <div className="flex flex-wrap border-b border-border mb-6 flex-shrink-0" data-id="element-1957">
        <button className={`flex items-center gap-2 px-3 py-2 text-sm font-medium border-b-2 tab-transition ${activeTab === 'notifications' ? 'border-black text-black' : 'border-transparent text-muted-foreground hover:text-foreground'}`} onClick={() => setActiveTab('notifications')} data-id="element-1958">
          <Bell size={16} data-id="element-1959" />
          <span data-id="element-1960">Notifications</span>
        </button>
        <button className={`flex items-center gap-2 px-3 py-2 text-sm font-medium border-b-2 tab-transition ${activeTab === 'security' ? 'border-black text-black' : 'border-transparent text-muted-foreground hover:text-foreground'}`} onClick={() => setActiveTab('security')} data-id="element-1961">
          <Lock size={16} data-id="element-1962" />
          <span data-id="element-1963">Security</span>
        </button>
        <button className={`flex items-center gap-2 px-3 py-2 text-sm font-medium border-b-2 tab-transition ${activeTab === 'integrations' ? 'border-black text-black' : 'border-transparent text-muted-foreground hover:text-foreground'}`} onClick={() => setActiveTab('integrations')} data-id="element-1964">
          <Globe size={16} data-id="element-1965" />
          <span data-id="element-1966">Integrations</span>
        </button>
        <button className={`flex items-center gap-2 px-3 py-2 text-sm font-medium border-b-2 tab-transition ${activeTab === 'storage' ? 'border-black text-black' : 'border-transparent text-muted-foreground hover:text-foreground'}`} onClick={() => setActiveTab('storage')} data-id="element-1967">
          <HardDrive size={16} data-id="element-1968" />
          <span data-id="element-1969">Storage</span>
        </button>
        <button className={`flex items-center gap-2 px-3 py-2 text-sm font-medium border-b-2 tab-transition ${activeTab === 'billing' ? 'border-black text-black' : 'border-transparent text-muted-foreground hover:text-foreground'}`} onClick={() => setActiveTab('billing')} data-id="element-1970">
          <CreditCard size={16} data-id="element-1971" />
          <span data-id="element-1972">Billing</span>
        </button>
        <button className={`flex items-center gap-2 px-3 py-2 text-sm font-medium border-b-2 tab-transition ${activeTab === 'support' ? 'border-black text-black' : 'border-transparent text-muted-foreground hover:text-foreground'}`} onClick={() => setActiveTab('support')} data-id="element-1973">
          <LifeBuoy size={16} data-id="element-1974" />
          <span data-id="element-1975">Support</span>
        </button>
        <button className={`flex items-center gap-2 px-3 py-2 text-sm font-medium border-b-2 tab-transition ${activeTab === 'systemStatus' ? 'border-black text-black' : 'border-transparent text-muted-foreground hover:text-foreground'}`} onClick={() => setActiveTab('systemStatus')} data-id="element-1976">
          <Activity size={16} data-id="element-1977" />
          <span data-id="element-1978">System Status</span>
        </button>
      </div>

      {/* Tab Content */}
      <div className="flex-1 rounded-md border overflow-y-auto bg-white" data-id="element-1979">
        {activeTab === 'notifications' && <div className="p-6 animate-fadeIn" data-id="element-1980">
            <h2 className="text-lg font-medium mb-4" data-id="element-1981">Notification Settings</h2>
            <p className="text-muted-foreground mb-6" data-id="element-1982">
              Manage how you receive notifications and alerts
            </p>

            <div className="space-y-6" data-id="element-1983">
              {/* Email Notifications */}
              <div className="border-b pb-6" data-id="element-1984">
                <h3 className="text-md font-medium mb-4" data-id="element-1985">
                  Email Notifications
                </h3>
                <div className="space-y-4" data-id="element-1986">
                  <div className="flex items-center justify-between" data-id="element-1987">
                    <div data-id="element-1988">
                      <div className="font-medium text-sm" data-id="element-1989">
                        Patient Registration Alerts
                      </div>
                      <div className="text-sm text-muted-foreground" data-id="element-1990">
                        Receive notifications when new patients register
                      </div>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer" data-id="element-1991">
                      <input type="checkbox" className="sr-only peer" defaultChecked data-id="element-1992" />
                      <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-gray-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-black" data-id="element-1993"></div>
                    </label>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-1994">
                    <div data-id="element-1995">
                      <div className="font-medium text-sm" data-id="element-1996">
                        Verification Required
                      </div>
                      <div className="text-sm text-muted-foreground" data-id="element-1997">
                        Alert when patient registrations need manual review
                      </div>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer" data-id="element-1998">
                      <input type="checkbox" className="sr-only peer" defaultChecked data-id="element-1999" />
                      <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-gray-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-black" data-id="element-2000"></div>
                    </label>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-2001">
                    <div data-id="element-2002">
                      <div className="font-medium text-sm" data-id="element-2003">Daily Summary</div>
                      <div className="text-sm text-muted-foreground" data-id="element-2004">
                        Receive a daily summary of all registrations
                      </div>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer" data-id="element-2005">
                      <input type="checkbox" className="sr-only peer" data-id="element-2006" />
                      <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-gray-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-black" data-id="element-2007"></div>
                    </label>
                  </div>
                </div>
              </div>

              {/* In-App Notifications */}
              <div className="border-b pb-6" data-id="element-2008">
                <h3 className="text-md font-medium mb-4" data-id="element-2009">
                  In-App Notifications
                </h3>
                <div className="space-y-4" data-id="element-2010">
                  <div className="flex items-center justify-between" data-id="element-2011">
                    <div data-id="element-2012">
                      <div className="font-medium text-sm" data-id="element-2013">
                        Desktop Notifications
                      </div>
                      <div className="text-sm text-muted-foreground" data-id="element-2014">
                        Show browser notifications for important events
                      </div>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer" data-id="element-2015">
                      <input type="checkbox" className="sr-only peer" defaultChecked data-id="element-2016" />
                      <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-gray-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-black" data-id="element-2017"></div>
                    </label>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-2018">
                    <div data-id="element-2019">
                      <div className="font-medium text-sm" data-id="element-2020">Sound Alerts</div>
                      <div className="text-sm text-muted-foreground" data-id="element-2021">
                        Play sound for new notifications
                      </div>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer" data-id="element-2022">
                      <input type="checkbox" className="sr-only peer" data-id="element-2023" />
                      <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-gray-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-black" data-id="element-2024"></div>
                    </label>
                  </div>
                </div>
              </div>

              <div className="flex justify-end" data-id="element-2025">
                <button className="asika-button" data-id="element-2026">Save Changes</button>
              </div>
            </div>
          </div>}

        {activeTab === 'security' && <div className="p-6 animate-fadeIn" data-id="element-2027">
            <h2 className="text-lg font-medium mb-4" data-id="element-2028">Security Settings</h2>
            <p className="text-muted-foreground mb-6" data-id="element-2029">
              Manage your account security and authentication
            </p>

            <div className="space-y-6" data-id="element-2030">
              {/* Password Management */}
              <div className="border-b pb-6" data-id="element-2031">
                <h3 className="text-md font-medium mb-4 flex items-center gap-2" data-id="element-2032">
                  <Key size={18} data-id="element-2033" />
                  Password Management
                </h3>
                <div className="space-y-4" data-id="element-2034">
                  <div data-id="element-2035">
                    <label className="block text-sm font-medium mb-2" data-id="element-2036">
                      Current Password
                    </label>
                    <input type="password" className="asika-input w-full" placeholder="Enter current password" data-id="element-2037" />
                  </div>
                  <div data-id="element-2038">
                    <label className="block text-sm font-medium mb-2" data-id="element-2039">
                      New Password
                    </label>
                    <input type="password" className="asika-input w-full" placeholder="Enter new password" data-id="element-2040" />
                  </div>
                  <div data-id="element-2041">
                    <label className="block text-sm font-medium mb-2" data-id="element-2042">
                      Confirm New Password
                    </label>
                    <input type="password" className="asika-input w-full" placeholder="Confirm new password" data-id="element-2043" />
                  </div>
                  <button className="asika-button" data-id="element-2044">Update Password</button>
                </div>
              </div>

              {/* Two-Factor Authentication */}
              <div className="border-b pb-6" data-id="element-2045">
                <h3 className="text-md font-medium mb-4 flex items-center gap-2" data-id="element-2046">
                  <Shield size={18} data-id="element-2047" />
                  Two-Factor Authentication
                </h3>
                <div className="bg-blue-50 border border-blue-200 rounded-md p-4 mb-4" data-id="element-2048">
                  <div className="flex items-start gap-3" data-id="element-2049">
                    <AlertTriangle size={20} className="text-blue-600 flex-shrink-0 mt-0.5" data-id="element-2050" />
                    <div data-id="element-2051">
                      <div className="font-medium text-sm text-blue-900" data-id="element-2052">
                        Not Enabled
                      </div>
                      <div className="text-sm text-blue-700" data-id="element-2053">
                        Add an extra layer of security to your account
                      </div>
                    </div>
                  </div>
                </div>
                <button className="asika-button" data-id="element-2054">Enable 2FA</button>
              </div>

              {/* Active Sessions */}
              <div data-id="element-2055">
                <h3 className="text-md font-medium mb-4 flex items-center gap-2" data-id="element-2056">
                  <Smartphone size={18} data-id="element-2057" />
                  Active Sessions
                </h3>
                <div className="space-y-3" data-id="element-2058">
                  <div className="border rounded-md p-4" data-id="element-2059">
                    <div className="flex items-center justify-between" data-id="element-2060">
                      <div data-id="element-2061">
                        <div className="font-medium text-sm" data-id="element-2062">
                          Current Session
                        </div>
                        <div className="text-sm text-muted-foreground" data-id="element-2063">
                          Chrome on Windows • New York, US
                        </div>
                        <div className="text-xs text-muted-foreground mt-1" data-id="element-2064">
                          Last active: Just now
                        </div>
                      </div>
                      <span className="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-green-100 text-green-800" data-id="element-2065">
                        Active
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>}

        {activeTab === 'integrations' && <div className="p-6 animate-fadeIn" data-id="element-2066">
            <h2 className="text-lg font-medium mb-4" data-id="element-2067">Integrations</h2>
            <p className="text-muted-foreground mb-6" data-id="element-2068">
              Connect and manage third-party integrations
            </p>

            <div className="space-y-4" data-id="element-2069">
              <div className="border rounded-md p-4" data-id="element-2070">
                <div className="flex items-start justify-between" data-id="element-2071">
                  <div className="flex items-start gap-3" data-id="element-2072">
                    <div className="h-12 w-12 bg-blue-100 rounded-lg flex items-center justify-center" data-id="element-2073">
                      <Database size={24} className="text-blue-600" data-id="element-2074" />
                    </div>
                    <div data-id="element-2075">
                      <div className="font-medium" data-id="element-2076">Epic EHR</div>
                      <div className="text-sm text-muted-foreground" data-id="element-2077">
                        Sync patient data with Epic EHR system
                      </div>
                      <span className="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-green-100 text-green-800 mt-2" data-id="element-2078">
                        Connected
                      </span>
                    </div>
                  </div>
                  <button className="px-3 py-1 border rounded-md text-sm hover:bg-gray-50" data-id="element-2079">
                    Configure
                  </button>
                </div>
              </div>

              <div className="border rounded-md p-4" data-id="element-2080">
                <div className="flex items-start justify-between" data-id="element-2081">
                  <div className="flex items-start gap-3" data-id="element-2082">
                    <div className="h-12 w-12 bg-purple-100 rounded-lg flex items-center justify-center" data-id="element-2083">
                      <FileText size={24} className="text-purple-600" data-id="element-2084" />
                    </div>
                    <div data-id="element-2085">
                      <div className="font-medium" data-id="element-2086">Insurance Portal</div>
                      <div className="text-sm text-muted-foreground" data-id="element-2087">
                        Verify insurance coverage automatically
                      </div>
                      <span className="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-green-100 text-green-800 mt-2" data-id="element-2088">
                        Connected
                      </span>
                    </div>
                  </div>
                  <button className="px-3 py-1 border rounded-md text-sm hover:bg-gray-50" data-id="element-2089">
                    Configure
                  </button>
                </div>
              </div>

              <div className="border rounded-md p-4" data-id="element-2090">
                <div className="flex items-start justify-between" data-id="element-2091">
                  <div className="flex items-start gap-3" data-id="element-2092">
                    <div className="h-12 w-12 bg-gray-100 rounded-lg flex items-center justify-center" data-id="element-2093">
                      <Mail size={24} className="text-gray-600" data-id="element-2094" />
                    </div>
                    <div data-id="element-2095">
                      <div className="font-medium" data-id="element-2096">Email Service</div>
                      <div className="text-sm text-muted-foreground" data-id="element-2097">
                        Send automated emails to patients
                      </div>
                      <span className="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-gray-100 text-gray-800 mt-2" data-id="element-2098">
                        Not Connected
                      </span>
                    </div>
                  </div>
                  <button className="asika-button text-sm" data-id="element-2099">Connect</button>
                </div>
              </div>
            </div>
          </div>}

        {activeTab === 'storage' && <div className="p-6 animate-fadeIn" data-id="element-2100">
            <h2 className="text-lg font-medium mb-4" data-id="element-2101">Storage Settings</h2>
            <p className="text-muted-foreground mb-6" data-id="element-2102">
              Manage your data storage and retention policies
            </p>

            <div className="space-y-6" data-id="element-2103">
              {/* Storage Usage */}
              <div className="border-b pb-6" data-id="element-2104">
                <h3 className="text-md font-medium mb-4" data-id="element-2105">Storage Usage</h3>
                <div className="bg-gray-50 rounded-lg p-4 mb-4" data-id="element-2106">
                  <div className="flex items-center justify-between mb-2" data-id="element-2107">
                    <span className="text-sm font-medium" data-id="element-2108">Used Storage</span>
                    <span className="text-sm font-medium" data-id="element-2109">2.4 GB / 10 GB</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-2110">
                    <div className="bg-black h-2 rounded-full" style={{
                  width: '24%'
                }} data-id="element-2111"></div>
                  </div>
                  <div className="text-xs text-muted-foreground mt-2" data-id="element-2112">
                    24% of your storage is being used
                  </div>
                </div>
                <div className="grid grid-cols-3 gap-4" data-id="element-2113">
                  <div className="border rounded-md p-3" data-id="element-2114">
                    <div className="text-2xl font-bold" data-id="element-2115">1.8 GB</div>
                    <div className="text-sm text-muted-foreground" data-id="element-2116">
                      Patient Documents
                    </div>
                  </div>
                  <div className="border rounded-md p-3" data-id="element-2117">
                    <div className="text-2xl font-bold" data-id="element-2118">0.4 GB</div>
                    <div className="text-sm text-muted-foreground" data-id="element-2119">
                      ID Documents
                    </div>
                  </div>
                  <div className="border rounded-md p-3" data-id="element-2120">
                    <div className="text-2xl font-bold" data-id="element-2121">0.2 GB</div>
                    <div className="text-sm text-muted-foreground" data-id="element-2122">
                      Other Files
                    </div>
                  </div>
                </div>
              </div>

              {/* Data Retention */}
              <div data-id="element-2123">
                <h3 className="text-md font-medium mb-4" data-id="element-2124">
                  Data Retention Policy
                </h3>
                <div className="space-y-4" data-id="element-2125">
                  <div data-id="element-2126">
                    <label className="block text-sm font-medium mb-2" data-id="element-2127">
                      Patient Records Retention
                    </label>
                    <select className="asika-input w-full" data-id="element-2128">
                      <option data-id="element-2129">Keep indefinitely</option>
                      <option data-id="element-2130">7 years (HIPAA compliant)</option>
                      <option data-id="element-2131">10 years</option>
                      <option data-id="element-2132">Custom period</option>
                    </select>
                  </div>
                  <div data-id="element-2133">
                    <label className="block text-sm font-medium mb-2" data-id="element-2134">
                      Automated Backups
                    </label>
                    <select className="asika-input w-full" data-id="element-2135">
                      <option data-id="element-2136">Daily</option>
                      <option data-id="element-2137">Weekly</option>
                      <option data-id="element-2138">Monthly</option>
                    </select>
                  </div>
                  <button className="asika-button" data-id="element-2139">Save Settings</button>
                </div>
              </div>
            </div>
          </div>}

        {activeTab === 'billing' && <div className="p-6 animate-fadeIn" data-id="element-2140">
            <h2 className="text-lg font-medium mb-4" data-id="element-2141">Billing & Subscription</h2>
            <p className="text-muted-foreground mb-6" data-id="element-2142">
              Manage your subscription and payment methods
            </p>

            <div className="space-y-6" data-id="element-2143">
              {/* Current Plan */}
              <div className="border-b pb-6" data-id="element-2144">
                <h3 className="text-md font-medium mb-4" data-id="element-2145">Current Plan</h3>
                <div className="border rounded-lg p-6 bg-blue-50" data-id="element-2146">
                  <div className="flex items-start justify-between mb-4" data-id="element-2147">
                    <div data-id="element-2148">
                      <div className="text-2xl font-bold" data-id="element-2149">
                        Professional Plan
                      </div>
                      <div className="text-muted-foreground" data-id="element-2150">
                        Perfect for growing practices
                      </div>
                    </div>
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-600 text-white" data-id="element-2151">
                      Active
                    </span>
                  </div>
                  <div className="text-3xl font-bold mb-2" data-id="element-2152">
                    $99
                    <span className="text-lg font-normal text-muted-foreground" data-id="element-2153">
                      /month
                    </span>
                  </div>
                  <div className="text-sm text-muted-foreground mb-4" data-id="element-2154">
                    Billed monthly • Next billing date: Feb 1, 2025
                  </div>
                  <button className="asika-button" data-id="element-2155">Upgrade Plan</button>
                </div>
              </div>

              {/* Payment Method */}
              <div className="border-b pb-6" data-id="element-2156">
                <h3 className="text-md font-medium mb-4" data-id="element-2157">Payment Method</h3>
                <div className="border rounded-md p-4 flex items-center justify-between" data-id="element-2158">
                  <div className="flex items-center gap-3" data-id="element-2159">
                    <div className="h-10 w-10 bg-gray-100 rounded flex items-center justify-center" data-id="element-2160">
                      <CreditCard size={20} data-id="element-2161" />
                    </div>
                    <div data-id="element-2162">
                      <div className="font-medium" data-id="element-2163">•••• •••• •••• 4242</div>
                      <div className="text-sm text-muted-foreground" data-id="element-2164">
                        Expires 12/2025
                      </div>
                    </div>
                  </div>
                  <button className="px-3 py-1 border rounded-md text-sm hover:bg-gray-50" data-id="element-2165">
                    Update
                  </button>
                </div>
              </div>

              {/* Billing History */}
              <div data-id="element-2166">
                <h3 className="text-md font-medium mb-4" data-id="element-2167">Billing History</h3>
                <div className="space-y-2" data-id="element-2168">
                  <div className="border rounded-md p-4 flex items-center justify-between" data-id="element-2169">
                    <div className="flex items-center gap-3" data-id="element-2170">
                      <Receipt size={20} className="text-muted-foreground" data-id="element-2171" />
                      <div data-id="element-2172">
                        <div className="font-medium" data-id="element-2173">January 2025</div>
                        <div className="text-sm text-muted-foreground" data-id="element-2174">
                          Professional Plan
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center gap-4" data-id="element-2175">
                      <div className="text-right" data-id="element-2176">
                        <div className="font-medium" data-id="element-2177">$99.00</div>
                        <div className="text-sm text-muted-foreground" data-id="element-2178">
                          Paid
                        </div>
                      </div>
                      <button className="text-black hover:underline text-sm" data-id="element-2179">
                        Download
                      </button>
                    </div>
                  </div>
                  <div className="border rounded-md p-4 flex items-center justify-between" data-id="element-2180">
                    <div className="flex items-center gap-3" data-id="element-2181">
                      <Receipt size={20} className="text-muted-foreground" data-id="element-2182" />
                      <div data-id="element-2183">
                        <div className="font-medium" data-id="element-2184">December 2024</div>
                        <div className="text-sm text-muted-foreground" data-id="element-2185">
                          Professional Plan
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center gap-4" data-id="element-2186">
                      <div className="text-right" data-id="element-2187">
                        <div className="font-medium" data-id="element-2188">$99.00</div>
                        <div className="text-sm text-muted-foreground" data-id="element-2189">
                          Paid
                        </div>
                      </div>
                      <button className="text-black hover:underline text-sm" data-id="element-2190">
                        Download
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>}

        {activeTab === 'support' && <div className="p-6 animate-fadeIn" data-id="element-2191">
            <h2 className="text-lg font-medium mb-4" data-id="element-2192">Support & Help</h2>
            <p className="text-muted-foreground mb-6" data-id="element-2193">
              Get help and contact support
            </p>

            <div className="space-y-6" data-id="element-2194">
              {/* Contact Support */}
              <div className="border-b pb-6" data-id="element-2195">
                <h3 className="text-md font-medium mb-4" data-id="element-2196">Contact Support</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2197">
                  <div className="border rounded-lg p-4 hover:bg-gray-50 cursor-pointer" data-id="element-2198">
                    <div className="flex items-center gap-3 mb-2" data-id="element-2199">
                      <div className="h-10 w-10 bg-blue-100 rounded-lg flex items-center justify-center" data-id="element-2200">
                        <MessageSquare size={20} className="text-blue-600" data-id="element-2201" />
                      </div>
                      <div className="font-medium" data-id="element-2202">Live Chat</div>
                    </div>
                    <div className="text-sm text-muted-foreground" data-id="element-2203">
                      Chat with our support team in real-time
                    </div>
                  </div>
                  <div className="border rounded-lg p-4 hover:bg-gray-50 cursor-pointer" data-id="element-2204">
                    <div className="flex items-center gap-3 mb-2" data-id="element-2205">
                      <div className="h-10 w-10 bg-green-100 rounded-lg flex items-center justify-center" data-id="element-2206">
                        <Mail size={20} className="text-green-600" data-id="element-2207" />
                      </div>
                      <div className="font-medium" data-id="element-2208">Email Support</div>
                    </div>
                    <div className="text-sm text-muted-foreground" data-id="element-2209">
                      Send us an email at support@asika.com
                    </div>
                  </div>
                  <div className="border rounded-lg p-4 hover:bg-gray-50 cursor-pointer" data-id="element-2210">
                    <div className="flex items-center gap-3 mb-2" data-id="element-2211">
                      <div className="h-10 w-10 bg-purple-100 rounded-lg flex items-center justify-center" data-id="element-2212">
                        <Headphones size={20} className="text-purple-600" data-id="element-2213" />
                      </div>
                      <div className="font-medium" data-id="element-2214">Phone Support</div>
                    </div>
                    <div className="text-sm text-muted-foreground" data-id="element-2215">
                      Call us at 1-800-ASIKA-HELP
                    </div>
                  </div>
                  <div className="border rounded-lg p-4 hover:bg-gray-50 cursor-pointer" data-id="element-2216">
                    <div className="flex items-center gap-3 mb-2" data-id="element-2217">
                      <div className="h-10 w-10 bg-orange-100 rounded-lg flex items-center justify-center" data-id="element-2218">
                        <BookOpen size={20} className="text-orange-600" data-id="element-2219" />
                      </div>
                      <div className="font-medium" data-id="element-2220">Documentation</div>
                    </div>
                    <div className="text-sm text-muted-foreground" data-id="element-2221">
                      Browse our comprehensive guides
                    </div>
                  </div>
                </div>
              </div>

              {/* Help Resources */}
              <div data-id="element-2222">
                <h3 className="text-md font-medium mb-4" data-id="element-2223">Help Resources</h3>
                <div className="space-y-3" data-id="element-2224">
                  <a href="#" className="flex items-center justify-between p-3 border rounded-md hover:bg-gray-50" data-id="element-2225">
                    <div className="flex items-center gap-3" data-id="element-2226">
                      <HelpCircle size={18} className="text-muted-foreground" data-id="element-2227" />
                      <span className="text-sm" data-id="element-2228">Getting Started Guide</span>
                    </div>
                    <ExternalLink size={16} className="text-muted-foreground" data-id="element-2229" />
                  </a>
                  <a href="#" className="flex items-center justify-between p-3 border rounded-md hover:bg-gray-50" data-id="element-2230">
                    <div className="flex items-center gap-3" data-id="element-2231">
                      <BookOpen size={18} className="text-muted-foreground" data-id="element-2232" />
                      <span className="text-sm" data-id="element-2233">API Documentation</span>
                    </div>
                    <ExternalLink size={16} className="text-muted-foreground" data-id="element-2234" />
                  </a>
                  <a href="#" className="flex items-center justify-between p-3 border rounded-md hover:bg-gray-50" data-id="element-2235">
                    <div className="flex items-center gap-3" data-id="element-2236">
                      <FileText size={18} className="text-muted-foreground" data-id="element-2237" />
                      <span className="text-sm" data-id="element-2238">Video Tutorials</span>
                    </div>
                    <ExternalLink size={16} className="text-muted-foreground" data-id="element-2239" />
                  </a>
                </div>
              </div>
            </div>
          </div>}

        {activeTab === 'systemStatus' && <div className="p-6 animate-fadeIn" data-id="element-2240">
            <h2 className="text-lg font-medium mb-4" data-id="element-2241">System Status</h2>
            <p className="text-muted-foreground mb-6" data-id="element-2242">
              Monitor system health and performance
            </p>

            <div className="space-y-6" data-id="element-2243">
              {/* Current Status */}
              <div className="border-b pb-6" data-id="element-2244">
                <h3 className="text-md font-medium mb-4" data-id="element-2245">Current Status</h3>
                <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-4" data-id="element-2246">
                  <div className="flex items-center gap-3" data-id="element-2247">
                    <div className="h-3 w-3 bg-green-500 rounded-full" data-id="element-2248"></div>
                    <div data-id="element-2249">
                      <div className="font-medium text-green-900" data-id="element-2250">
                        All Systems Operational
                      </div>
                      <div className="text-sm text-green-700" data-id="element-2251">
                        Last updated: 2 minutes ago
                      </div>
                    </div>
                  </div>
                </div>

                <div className="space-y-3" data-id="element-2252">
                  <div className="flex items-center justify-between p-3 border rounded-md" data-id="element-2253">
                    <div className="flex items-center gap-3" data-id="element-2254">
                      <Server size={18} className="text-muted-foreground" data-id="element-2255" />
                      <div data-id="element-2256">
                        <div className="font-medium text-sm" data-id="element-2257">API Services</div>
                        <div className="text-xs text-muted-foreground" data-id="element-2258">
                          Response time: 45ms
                        </div>
                      </div>
                    </div>
                    <span className="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-green-100 text-green-800" data-id="element-2259">
                      Operational
                    </span>
                  </div>
                  <div className="flex items-center justify-between p-3 border rounded-md" data-id="element-2260">
                    <div className="flex items-center gap-3" data-id="element-2261">
                      <Database size={18} className="text-muted-foreground" data-id="element-2262" />
                      <div data-id="element-2263">
                        <div className="font-medium text-sm" data-id="element-2264">Database</div>
                        <div className="text-xs text-muted-foreground" data-id="element-2265">
                          Query time: 12ms
                        </div>
                      </div>
                    </div>
                    <span className="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-green-100 text-green-800" data-id="element-2266">
                      Operational
                    </span>
                  </div>
                  <div className="flex items-center justify-between p-3 border rounded-md" data-id="element-2267">
                    <div className="flex items-center gap-3" data-id="element-2268">
                      <Zap size={18} className="text-muted-foreground" data-id="element-2269" />
                      <div data-id="element-2270">
                        <div className="font-medium text-sm" data-id="element-2271">AI Agent</div>
                        <div className="text-xs text-muted-foreground" data-id="element-2272">
                          Processing: 3.2s avg
                        </div>
                      </div>
                    </div>
                    <span className="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-green-100 text-green-800" data-id="element-2273">
                      Operational
                    </span>
                  </div>
                </div>
              </div>

              {/* Performance Metrics */}
              <div data-id="element-2274">
                <h3 className="text-md font-medium mb-4" data-id="element-2275">
                  Performance Metrics (Last 24 Hours)
                </h3>
                <div className="grid grid-cols-3 gap-4" data-id="element-2276">
                  <div className="border rounded-md p-4" data-id="element-2277">
                    <div className="text-2xl font-bold" data-id="element-2278">99.9%</div>
                    <div className="text-sm text-muted-foreground" data-id="element-2279">Uptime</div>
                  </div>
                  <div className="border rounded-md p-4" data-id="element-2280">
                    <div className="text-2xl font-bold" data-id="element-2281">1,247</div>
                    <div className="text-sm text-muted-foreground" data-id="element-2282">
                      Registrations
                    </div>
                  </div>
                  <div className="border rounded-md p-4" data-id="element-2283">
                    <div className="text-2xl font-bold" data-id="element-2284">42ms</div>
                    <div className="text-sm text-muted-foreground" data-id="element-2285">
                      Avg Response
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>}
      </div>
    </div>;
};
export default Settings;